<template>
  <div id="app-list-component">
    <div class="max-w-6xl mx-auto px-4 sm:px-6">
      <div class="pb-12 md:pb-20">
        <div>
          <div v-for="section in list" class="mt-12 md:mt-16">
            <h3 id="engineering" class="scroll-mt-8 text-2xl font-bold inline-flex bg-clip-text text-transparent bg-linear-to-r from-slate-200/60 via-slate-200 to-slate-200/60 pb-8">
              {{ section.website.name }}
            </h3>
            <div class="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              <template v-for="app in section.apps">
                <app-list-item :app="app" />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import AppListItem from "~/components/local/app/app-list-item.vue";

// import IntegrationsImg01 from '~/assets/template/images/integrations-01.svg'
// import IntegrationsImg02 from '~/assets/template/images/integrations-02.svg'
// import IntegrationsImg03 from '~/assets/template/images/integrations-03.svg'
// import IntegrationsImg04 from '~/assets/template/images/integrations-04.svg'
// import IntegrationsImg05 from '~/assets/template/images/integrations-05.svg'
// import IntegrationsImg06 from '~/assets/template/images/integrations-06.svg'
// import IntegrationsImg07 from '~/assets/template/images/integrations-07.svg'
// import IntegrationsImg08 from '~/assets/template/images/integrations-08.svg'
// import IntegrationsImg09 from '~/assets/template/images/integrations-09.svg'
// import IntegrationsImg10 from '~/assets/template/images/integrations-10.svg'
// import IntegrationsImg11 from '~/assets/template/images/integrations-11.svg'
// import IntegrationsImg12 from '~/assets/template/images/integrations-12.svg'
// import IntegrationsImg13 from '~/assets/template/images/integrations-13.svg'
// import IntegrationsImg14 from '~/assets/template/images/integrations-14.svg'
// import IntegrationsImg15 from '~/assets/template/images/integrations-15.svg'
// import IntegrationsImg16 from '~/assets/template/images/integrations-16.svg'
// import IntegrationsImg17 from '~/assets/template/images/integrations-17.svg'
// import IntegrationsImg18 from '~/assets/template/images/integrations-18.svg'
// import IntegrationsImg19 from '~/assets/template/images/integrations-19.svg'
// import IntegrationsImg20 from '~/assets/template/images/integrations-20.svg'
// import IntegrationsImg21 from '~/assets/template/images/integrations-21.svg'
// import IntegrationsImg22 from '~/assets/template/images/integrations-22.svg'
// import IntegrationsImg23 from '~/assets/template/images/integrations-23.svg'
// import IntegrationsImg24 from '~/assets/template/images/integrations-24.svg'

import youtubeLogo from "~/assets/apps/youtube/logo.1.png";

const list = [
  {
    website: {
      name: "Youtube"
    },
    apps: [
      {
        name: "Thumbnail Downloader",
        featured: false,
        logo: youtubeLogo,
        url: { name: "apps-youtube-thumbnail-downloader" },
        description: "Download a YouTube video's thumbnail instantly by pasting a URL or ID. Fast, simple, and responsive."
      }
    ]
  }
];

// const items = [
//   {
//     img: IntegrationsImg06,
//     name: 'Vercel',
//     description: 'Stellar makes it easy to build extensions by providing an authentication provider that handles the OAuth flow.',
//     link: '/integrations-single',
//     featured: true,
//     category: 'Engineering'
//   }
// ]
</script>
